export default __webpack_public_path__ + "static/media/steve_raffle.cc5b8762.png";